import type { RouteConfigMatch } from "@gamedev-web/gamedev-sdk-core";

export const getPageId = (routeMatch: RouteConfigMatch, locale: string) => {
  if (routeMatch.formatPageId) {
    return routeMatch.formatPageId(routeMatch, locale);
  } else {
    return routeMatch.match?.url || "/";
  }
};
